import * as React from 'react';

export default function RacketTwo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={props.viewBox || '0 0 24 24'}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8 2.40039C10.3454 2.40039 9.92993 2.65719 9.72666 3.06373L8.85834 4.80039H4.79998C4.13723 4.80039 3.59998 5.33765 3.59998 6.00039C3.59998 6.66313 4.13723 7.20039 4.79998 7.20039L4.79998 19.2004C4.79998 20.5259 5.87449 21.6004 7.19998 21.6004H16.8C18.1255 21.6004 19.2 20.5259 19.2 19.2004V7.20039C19.8627 7.20039 20.4 6.66313 20.4 6.00039C20.4 5.33765 19.8627 4.80039 19.2 4.80039H15.1416L14.2733 3.06373C14.07 2.65719 13.6545 2.40039 13.2 2.40039H10.8ZM8.39998 9.60039C8.39998 8.93765 8.93723 8.40039 9.59998 8.40039C10.2627 8.40039 10.8 8.93765 10.8 9.60039V16.8004C10.8 17.4631 10.2627 18.0004 9.59998 18.0004C8.93723 18.0004 8.39998 17.4631 8.39998 16.8004V9.60039ZM14.4 8.40039C13.7372 8.40039 13.2 8.93765 13.2 9.60039V16.8004C13.2 17.4631 13.7372 18.0004 14.4 18.0004C15.0627 18.0004 15.6 17.4631 15.6 16.8004V9.60039C15.6 8.93765 15.0627 8.40039 14.4 8.40039Z"
        fill="currentColor"
      />
    </svg>
  );
}
